import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AdBanner } from './components/AdComponents';
import { Navigation } from "./components/Navigation";
import { HomePage } from "./pages/HomePage";
import { PinCodesPage } from "./pages/PinCodesPage";
import { IfscCodesPage } from "./pages/IfscCodesPage";
import { StdCodesPage } from "./pages/StdCodesPage";
import { RtoCodesPage } from "./pages/RtoCodesPage";
import { RailwayCodesPage } from "./pages/RailwayCodesPage";
import { UssdCodesPage } from "./pages/UssdCodesPage";
import { HtmlColorsPage } from "./pages/HtmlColorsPage";
import { FestivalsPage } from "./pages/FestivalsPage";
import { CricketPage } from "./pages/CricketPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function AppContent() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="pb-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pin-codes" element={<PinCodesPage />} />
          <Route path="/ifsc-codes" element={<IfscCodesPage />} />
          <Route path="/std-codes" element={<StdCodesPage />} />
          <Route path="/rto-codes" element={<RtoCodesPage />} />
          <Route path="/railway-codes" element={<RailwayCodesPage />} />
          <Route path="/ussd-codes" element={<UssdCodesPage />} />
          <Route path="/html-colors" element={<HtmlColorsPage />} />
          <Route path="/festivals" element={<FestivalsPage />} />
          <Route path="/cricket" element={<CricketPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      
      {/* Footer for ad space and credits */}
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Indian Codes Hub</h3>
            <p className="text-sm text-gray-600 mb-4">
              Your trusted source for all Indian codes and reference information
            </p>
            
            {/* Footer Ad */}
            {/* <div className="mb-6 flex justify-center">
              <AdBanner size="banner" />
            </div> */}
            
            <div className="border-t border-gray-200 pt-6">
              <p className="text-sm text-gray-500">
                © 2025 Indian Codes Hub. All rights reserved.
              </p>
              <p className="text-xs text-gray-400 mt-2">
                Data updated regularly for accuracy. For commercial use, please verify with official sources.
              </p>
            </div>
          </div>
        </div>
      </footer>
      
      <Toaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}